import { Command } from 'cmdk';
import type { IconName } from '@customerio/pluma-icons';
import { Box, Flex, Icon, Text } from '@customerio/pluma-components/react';
import type { LocalCommand } from './local-commands';

export type LocalCommandsSectionProps = {
  settingsCommands: LocalCommand[];
  hydraCommands: LocalCommand[];
  /** 0-based count of items rendered before this section, used to compute 1-based Result Position. */
  baseOffset: number;
  onSelect: (action: () => void | Promise<void>, position: number) => void;
};

export function LocalCommandsSection({
  settingsCommands,
  hydraCommands,
  baseOffset,
  onSelect,
}: LocalCommandsSectionProps) {
  return (
    <>
      {settingsCommands.length > 0 ? (
        <Command.Group heading="Settings">
          {settingsCommands.map((cmd, index) => (
            <Command.Item
              key={`local-${cmd.id}`}
              value={`local-${cmd.id}`}
              onSelect={() => onSelect(cmd.onSelect, 1 + baseOffset + index)}
              asChild
            >
              <Box alignItems="flex-start" gap="050" display="flex">
                <Icon mt="025" size="sm" sizeVersion="v2" color="base" name={(cmd.icon ?? 'command') as IconName} />
                <Flex direction="column" w="full">
                  <Text text="product-p" truncate w="full">
                    {cmd.label}
                  </Text>
                  {cmd.description != null ? (
                    <Text size="xxs" color="subtle" truncate w="full">
                      {cmd.description}
                    </Text>
                  ) : null}
                </Flex>
              </Box>
            </Command.Item>
          ))}
        </Command.Group>
      ) : null}
      {hydraCommands.length > 0 ? (
        <Command.Group heading="Quick actions">
          {hydraCommands.map((cmd, index) => (
            <Command.Item
              key={`local-${cmd.id}`}
              value={`local-${cmd.id}`}
              onSelect={() => onSelect(cmd.onSelect, 1 + baseOffset + settingsCommands.length + index)}
              asChild
            >
              <Box alignItems="flex-start" gap="050" display="flex">
                <Icon mt="025" size="sm" sizeVersion="v2" color="base" name={(cmd.icon ?? 'command') as IconName} />
                <Flex direction="column" w="full">
                  <Text text="product-p" truncate w="full">
                    {cmd.label}
                  </Text>
                  {cmd.description != null ? (
                    <Text size="xxs" color="subtle" truncate w="full">
                      {cmd.description}
                    </Text>
                  ) : null}
                </Flex>
              </Box>
            </Command.Item>
          ))}
        </Command.Group>
      ) : null}
    </>
  );
}
